"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireDefault(require("react"));

require("minireset.css");

require("antd/dist/antd.css");

require("react-draft-wysiwyg/dist/react-draft-wysiwyg.css");

require("draft-js/dist/Draft.css");

var _Loader = _interopRequireDefault(require("./components/Loader"));

var _store = require("./store"); // import external css files
// import app components


var Master = /*#__PURE__*/_react.default.lazy(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require('./components/Master'));
  });
});

var JamCMS = function JamCMS(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_Loader.default, null)
  }, /*#__PURE__*/_react.default.createElement(_store.StoreProvider, props, /*#__PURE__*/_react.default.createElement(Master, {
    defaultComponent: props.children
  })));
};

var _default = JamCMS;
exports.default = _default;